import { Component, NgZone, OnDestroy, OnInit, inject, input, output } from '@angular/core';
import { Button } from 'primeng/button';
import { fromEvent, Subscription } from 'rxjs';
import { PanelButtonIcon } from '../../models/panel-button-icon.model';

@Component({
    selector: 'gis-panel',
    imports: [
    Button
],
    templateUrl: './panel.component.html',
    styleUrl: './panel.component.scss'
})
export class PanelComponent implements OnInit, OnDestroy {
  protected readonly PanelButtonIcon = PanelButtonIcon;
  private readonly ngZone = inject(NgZone);

  readonly position = input<'left' | 'right'>('right');
  readonly buttonLabel = input('');
  readonly buttonLabelSuffix = input('');
  readonly buttonIcon = input<PanelButtonIcon | ''>('');
  readonly buttonStyle = input<{
    [key: string]: unknown;
} | null>(null);
  readonly panelWidth = input<string>();
  readonly isOverlay = input(false);
  readonly isToggled = output<void>();
  resizeObserver?: ResizeObserver;
  bodyElement = document.querySelector('body') as HTMLElement;
  show = false;
  clickSubscripton?: Subscription;
  latestBodyWidth = 0;
  innerWidth = '0';

  constructor() {
    this.setPanelWidth = this.setPanelWidth.bind(this);
  }

  ngOnInit() {
    this.resizeObserver = new ResizeObserver(this.setPanelWidth);
    this.resizeObserver.observe(this.bodyElement);

    const questionComponentElement = document.querySelector('#questions-container');
    if (questionComponentElement) {
      this.clickSubscripton = fromEvent(questionComponentElement, 'click').subscribe(() => {
        this.show = false;
      });
    }
  }

  ngOnDestroy() {
    this.resizeObserver?.unobserve(this.bodyElement);
    this.clickSubscripton?.unsubscribe();
  }

  onInnerContainerClick(event: UIEvent) {
    event.stopPropagation(); // Prevent clickSubscription next().
  }

  setPanelWidth() {
    const bodyWidth = this.bodyElement.clientWidth;
    if (this.latestBodyWidth !== bodyWidth) {
      const sideMargins = 40;
      this.latestBodyWidth = bodyWidth

      this.ngZone.run(() => {
        if (bodyWidth > 800) {
          this.innerWidth = this.panelWidth() ?? '100%';
        } else {
          const width = bodyWidth - sideMargins;
          this.innerWidth = `${width}px`;
        }
      });
    }
  }

  togglePanel(event: MouseEvent) {
    event.stopPropagation();
    this.show = !this.show;
    this.isToggled.emit();
  }

  hidePanel() {
    this.show = false;
  }
}
